module.exports = __webpack_public_path__ + "img/home3.475af079.png";